import { computed } from "vue";
import { useResultsV2Store } from "@stores/survey/resultsV2/resultsV2";
import { useResultsV2CardsStore } from "@stores/survey/resultsV2/resultsV2.cards";

export function useCardLocalOptions(card) {
  const store = useResultsV2Store();
  const cardsStore = useResultsV2CardsStore();

  const localOptions = computed(() => card.value?.options || {});

  function updateLocalOption(key, value) {
    cardsStore.updateCardLocal(card.value.id, {
      options: { ...localOptions.value, [key]: value },
    });
  }

  return { store, localOptions, updateLocalOption };
}
